/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {logInfo} from "App/debug";
import RenderObject from "App/geometry/objects/object";

export default
class Factory {
    private static UID: number = 1;
    private static registeredObjects: {} = {};

    public static register(aClass: any) {
        Factory.registeredObjects[aClass.TypeName] = aClass;
    }

    /***
     * Create geometry object isntance based on input shape json. We pass through registered types and as soon as we found
     * first registered type in the shape json boject, we create appropriate geometry object instance.
     *
     * @param aShapeJSON We need to have the shape JSON at input because in the geometry description there is no geometry type
     *                   definition but the shapeJSON has member e.g. binaryGeometry or textGeometry etc. This is wrong export
     *                   but it is too costly to change it now.
     * @returns {aObject}
     */
    public static create(aShapeJSON: any, aObject: RenderObject): any
    {
        for (let key in Factory.registeredObjects) {
            if (aShapeJSON.hasOwnProperty(key)) {
                Factory.UID++;
                let object = Factory.registeredObjects[key].create(aObject);
                object._classTypeName = key;
                return {
                    geometry: object,
                    type: key
                }
            }
        }

        logInfo("Cannot found registered geometry for shape json object " + aShapeJSON);
        return null;
    }
}